<div class="main-content table-page table-page--compact prioridades-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Prioridades</h1>
        <p>Consulte y actualice el tiempo configurado para cada nivel de prioridad de tickets.</p>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="paginatedPrioridades.length > 0; else prioridadesEmptyState">
          <thead>
            <tr>
              <th>Prioridad</th>
              <th>Tiempo estimado</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of paginatedPrioridades">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ row.nombre || 'Sin nombre' }}</strong>
                  <span class="table-page__subtext">Configuración de SLA</span>
                </div>
              </td>
              <td>
                <span class="table-page__status-badge is-active">{{ row.tiempo_en_horas }} horas</span>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="modificarTiempoPrioridad(row)">
                  <i class="material-icons">edit</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #prioridadesEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else prioridadesLoadingState">
            <i class="material-icons">rule</i>
            <strong>No se encontraron prioridades</strong>
            <span>Cuando existan prioridades configuradas aparecerán en este listado.</span>
          </div>
        </ng-template>

        <ng-template #prioridadesLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando prioridades...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ listaPrioridades.length }} prioridades</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">Inicio</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">Anterior</button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else prioridadesPagerEllipsis" type="button" class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>
            <ng-template #prioridadesPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">Último</button>
        </div>
      </div>
    </section>
  </div>
</div>
